import { Modal as ModalBtn } from 'antd';
import styled from 'styled-components';

export const ModalPlaca = styled(ModalBtn)`
  .ant-modal-header {
    border-bottom: 0;
    .ant-modal-title {
      font-size: 28px;
      font-weight: 300;
      color: #676a6c;
      padding: 10px;
    }
  }
  .ant-modal-footer {
    border-top: 0;
    .ant-btn-primary {
      background: #449d44;
      border-color: #449d44;
    }
  }
`;
